import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TimestampPipe } from '@scandium-oy/ngx-scandium';
import { AppCommonModule } from 'src/app/common.module';
import { ApartmentRoundReport } from 'src/app/models/apartment-round.model';

@Component({
  selector: 'app-print-apartment-round',
  templateUrl: './print-apartment-round.component.html',
  styleUrls: ['./print-apartment-round.component.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    TimestampPipe,
  ],
})
export class PrintApartmentRoundComponent {

  report = input.required<ApartmentRoundReport>();
  siteImage = input<string>();
}
